export type Flushable = { flush: () => void };

const registry = new Set<Flushable>();

export const registerDebounced = (fn: Flushable) => {
  registry.add(fn);
};

export const unregisterDebounced = (fn: Flushable) => {
  registry.delete(fn);
};

export const flushAllDebounced = () => {
  registry.forEach((fn) => fn.flush());
};
